import { BaseModel, Default } from '@red/data-access';
import { Expose, Transform, Type } from 'class-transformer';
export class BonusChartDto extends BaseModel {
  @Expose()
  @Type(() => Number)
  appointmentTypeId!: number;

  @Expose()
  @Type(() => Number)
  l1Percent!: number;

  @Expose()
  @Type(() => Number)
  icWeightage!: number;

  @Expose()
  @Type(() => Number)
  poolWeightage!: number;
}
export class BonusDistributionCreateDto extends BaseModel {
  @Expose()
  @Transform(params => params.value.trim())
  code!: string;

  @Expose()
  @Transform(params => params.value.trim())
  name!: string;

  @Expose()
  @Type(() => BonusChartDto)
  bonusCharts!: BonusChartDto[];

  @Expose()
  @Type(() => Boolean)
  @Default(false)
  isActive!: boolean;

  @Expose()
  status!: string;
}

export class BonusDistributionDataUpdateDto extends BaseModel {
  @Expose({ groups: ['full', 'general'] })
  @Transform(params => params.value.trim())
  code!: string;

  @Expose({ groups: ['full', 'general'] })
  @Transform(params => params.value.trim())
  name!: string;

  @Expose({ groups: ['full', 'chart'] })
  @Type(() => BonusChartDto)
  bonusCharts!: BonusChartDto[];

  @Expose({ groups: ['full', 'general', 'isActive'] })
  @Type(() => Boolean)
  @Default(false)
  isActive!: boolean;
}

export class BonusDistributionUpdateDto extends BaseModel {
  @Expose()
  @Default('full')
  group!: 'general' | 'chart' | 'isActive' | 'full';

  @Expose()
  @Transform(params => {
    return BonusDistributionDataUpdateDto.fromJson(params.value, { groups: [params.obj.group] });
  })
  data!: BonusDistributionDataUpdateDto;
}
